import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  dealUsers: [],
  selectedDealUser: null,
};

export default (state = initialState, action) => {
  let index;

  switch (action.type) {
    case actionTypes.DEAL_USERS_GET_REQUEST:
    case actionTypes.DEAL_USER_GET_REQUEST:
    case actionTypes.DEAL_USER_CREATE_REQUEST:
    case actionTypes.DEAL_USER_UPDATE_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.DEAL_USERS_GET_ERROR:
      return { ...state, status: action.type, dealUsers: [] };

    case actionTypes.DEAL_USERS_GET_SUCCESS:
      return { ...state, status: action.type, dealUsers: action.dealUsers };

    case actionTypes.DEAL_USER_GET_ERROR:
    case actionTypes.DEAL_USER_CREATE_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        selectedDealUser: null,
      };

    case actionTypes.DEAL_USER_GET_SUCCESS:
    case actionTypes.DEAL_USER_SELECT:
      return {
        ...state,
        status: action.type,
        selectedDealUser: action.dealUser,
      };

    case actionTypes.DEAL_USER_CREATE_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedDealUser: action.dealUser,
        dealUsers: state.dealUsers.concat(action.dealUser),
      };

    case actionTypes.DEAL_USER_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.dealUser.id))(state.dealUsers);
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          selectedDealUser: action.dealUser,
          dealUsers: state.dealUsers.concat(action.dealUser),
        };
      } else {
        const dealUser = state.dealUsers[index];
        state.dealUsers[index] = {
          ...action.dealUser,
          publishers: dealUser.publishers || [],
        };
        return {
          ...state,
          status: action.type,
          selectedDealUser: action.dealUser,
          dealUsers: [...state.dealUsers],
        };
      }

    case actionTypes.DEAL_USER_DELETE_SUCCESS:
      index = R.findIndex(R.propEq('id', parseInt(action.dealUserId, 10)))(
        state.dealUsers
      );
      if (index !== -1) {
        return {
          ...state,
          status: action.type,
          selectedDealUser: null,
          dealUsers: R.remove(index, 1, state.dealUsers),
        };
      } else {
        return { ...state, status: action.type, selectedDealUser: null };
      }

    case actionTypes.PUBLISHER_CREATE_SUCCESS:
      index = R.findIndex(R.propEq('user', action.publisher.user))(
        state.dealUsers
      );
      if (index !== -1) {
        const publishers = state.dealUsers[index].publishers || [];
        state.dealUsers[index].publishers = [...publishers, action.publisher];
        return { ...state, dealUsers: [...state.dealUsers] };
      }
      return state;

    case actionTypes.PUBLISHER_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('user', action.publisher.user))(
        state.dealUsers
      );
      if (index !== -1) {
        const publishers = state.dealUsers[index].publishers || [];
        const index2 = R.findIndex(R.propEq('id', action.publisher.id))(
          publishers
        );
        if (index !== -1) {
          state.dealUsers[index].publishers[index2] = action.publisher;
          return { ...state, dealUsers: [...state.dealUsers] };
        }
      }
      return state;

    case actionTypes.PUBLISHER_DELETE_SUCCESS:
      index = R.findIndex(R.propEq('user', action.publisher.user))(
        state.dealUsers
      );
      if (index !== -1) {
        const publishers = state.dealUsers[index].publishers || [];
        const index2 = R.findIndex(R.propEq('id', action.publisher.id))(
          publishers
        );
        if (index !== -1) {
          state.dealUsers[index].publishers = R.remove(index2, 1, publishers);
          return { ...state, dealUsers: [...state.dealUsers] };
        }
      }
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/dealUsers.js